export default __webpack_public_path__ + "static/media/2440.b373026d.png";